<div class="section-full p-t80 p-b50 bg-gray">
    <div class="container">
        <div class="section-content">

            <div class="section-content">
                <div class="pricingtable-row p-lr15 no-col-gap">
                    <div class="row d-flex justify-content-center">
                    

                        <div class="col-lg-4 col-md-6 col-sm-12 m-b30" *ngFor="let object of data; let i=index;">
                            <div class="pricingtable-wrapper {{i!=1 ? 'bg-white' : ''}}">
                                <div class="pricingtable-inner {{i==1 ? 'pricingtable-highlight' : ''}}">
                                    <div class="pricing-table-top-section">
                                        <div class="pricingtable-price">
                                            <span class="pricingtable-type">Installation</span>                                                    
                                            <h2 class="pricingtable-bx"><sup class="pricingtable-sign">$</sup>{{object.price}}</h2>
                                        </div>
                                        
                                        <div class="pricingtable-title">
                                            <h2 class="title-style-2">{{object.plan}} Plan</h2>
                                        </div>                                                    
                                    </div>
                                    
                                    <ul class="pricingtable-features">
                                        <li>{{object.description}} </li>
                                    </ul>
                                    
                                    <div class="pricingtable-footer">
                                        <a routerLink="/other/our-prices" class="{{i==1 ? 'site-button-secondry' : 'site-button'}} site-btn-effect">Select</a>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>    
            
        </div>
    </div>
</div>  